import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { Element } from 'react-scroll';
import styled from 'styled-components';
import LoadingScreen from '../LoadingScreen';
const Search = lazy(() => import('../../components/customers/search'));

const Wrapper = styled.div`
  .search-page {
    transition: all 0.3s ease;
    width: 100%;
    background: #ffffff;
    position: fixed;
    z-index: 1003;
    top: 0;
    bottom: 0;
    overflow: auto;
    transition: all 0.2s ease-in-out;
  }
  .search-page {
    background: rgba(255, 255, 255, 0.95);
  }
  .search-page.close {
    height: 0;
  }

  .search-page.open {
    height: 100%;
  }
`;

function SearchWrapper({ showSearch, setShowSearch }) {
  const [searchLoaded, setSearchLoaded] = useState(false);
  const searchPage = useRef(null);

  useEffect(() => {
    if (showSearch) {
      if (!searchLoaded) {
        setSearchLoaded(true);
      }
      document.body.classList.add('modal-open');
      searchPage.current.scrollTo(0, 0);
      setTimeout(() => {
        searchPage.current.scrollTo(0, 0);
      }, 550);
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [showSearch]);

  return (
    <Wrapper>
      <Element
        name="element-container"
        className={`search-page ${showSearch ? 'open' : 'close'}`}
        id="containerSearchElement"
      >
        <div ref={searchPage}>
          {searchLoaded && (
            <Suspense fallback={<LoadingScreen />}>
              <Search modal setShowSearch={setShowSearch} />
            </Suspense>
          )}
        </div>
      </Element>
    </Wrapper>
  );
}

export default SearchWrapper;
